import LogRocket from "logrocket"; // see https://github.com/motdotla/dotenv#how-do-i-use-dotenv-with-import
LogRocket.init("gotvyh/dealers-choice", {
  shouldCaptureIP: false,
});

export default LogRocket;
